import { marked } from "marked";
import TurndownService from "turndown";

const turndownService = new TurndownService({
  headingStyle: "atx",
  codeBlockStyle: "fenced",
  bulletListMarker: "-",
  emDelimiter: "*",
  strongDelimiter: "**",
  linkStyle: "inlined",
  linkReferenceStyle: "full",
});

turndownService.addRule("sourceMapLink", {
  filter: (node) =>
    node.nodeName === "A" &&
    (node as HTMLElement).classList?.contains("source-map-link"),
  replacement: (_content, node) => (node as HTMLElement).outerHTML,
});

// Preserve text highlights as inline <mark> HTML so they survive the
// markdown round-trip and can be rendered/exported downstream.
turndownService.addRule("highlight", {
  filter: ["mark"],
  replacement: (content) => `<mark>${content}</mark>`,
});

export function htmlToMarkdown(html: string): string {
  if (!html || html.trim() === "") {
    return "";
  }

  return turndownService.turndown(html);
}

/**
 * Convert markdown text to HTML
 */
export async function markdownToHtml(markdown: string): Promise<string> {
  if (!markdown || markdown.trim() === "") {
    return "";
  }

  return await marked.parse(markdown);
}

/**
 * Synchronous version of markdownToHtml
 */
export function markdownToHtmlSync(markdown: string): string {
  if (!markdown || markdown.trim() === "") {
    return "";
  }

  // Use marked with async: false option for synchronous parsing
  return marked.parse(markdown, { async: false }) as string;
}
